<onyx-section [heading]="`${I18N}.heading`" [count]="documents()?.length">
  <onyx-button
    options
    variant="outlined"
    [size]="32"
    leftIcon="add-outlined"
    (click)="addDocument()"
  >
    {{ 'labels.add' | translate }}
  </onyx-button>

  @if (documents()?.length !== 0) {
    <onyx-table
      [data]="documents()"
      [columns]="columns()"
      [rowSize]="48"
      [tableShadow]="false"
      [showHeader]="false"
      [rowOptions]="getDocumentOptions"
    ></onyx-table>
  }
</onyx-section>

<ng-template let-value="value" #documentFileTemplate>
  @if (value != null) {
    <onyx-upload
      [value]="value"
      [disabled]="true"
      [hideBorder]="true"
      [size]="32"
    ></onyx-upload>
  } @else {
    <span>{{ 'labels.noFile' | translate }}</span>
  }
</ng-template>
